import { Mixpanel } from 'features/Analytics/vendors/mixpanel';

const PRODUCT = 'Client Portal 2';

const isMixpanelEnabled = !!process.env.PUBLIC_MIXPANEL_TOKEN;

export const initTracking = () => {
	if (isMixpanelEnabled) {
		Mixpanel.init();
	}
};

export const identifyUser = (userId: string) => {
	if (isMixpanelEnabled) {
		Mixpanel.identify(userId);
	}
};

export const track = (
	eventName: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	eventProperties: Record<string, any> = {},
) => {
	if (isMixpanelEnabled) {
		Mixpanel.track(eventName, { ...eventProperties, Product: PRODUCT });
	}
};

export const addEventProperties = (
	eventName: string,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	eventProperties: Record<string, any>,
) => {
	if (isMixpanelEnabled) {
		Mixpanel.track(eventName, eventProperties);
	}
};

export const resetAnalytics = () => {
	if (isMixpanelEnabled) {
		Mixpanel.reset();
	}
};

// utility to wait for analytics to be initialized before calling the callback
export const waitForAnalytics = (callback: () => void) => {
	return Mixpanel.waitForAnalytics(callback);
};
